import Vue from "vue";
import Vuex from "vuex";
import * as productType from "@/store/modules/productType.js";
import * as notification from "@/store/modules/notification.js";
import * as cart from "@/store/modules/cart.js";
import * as data from "@/store/modules/data.js";
import {saveStatePlugin} from '@/utils.js';
import Config from '@/config.js';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [saveStatePlugin],
  state: {
    config: Config,
    selectedLocale: localStorage.getItem("selectedLocale") || "fr"
  },
  mutations: {
    CHANGE_LOCALE(state, locale) {
      state.selectedLocale = locale;
    }
  },
  actions: {
    changeLocale({commit}, locale) {
      commit("CHANGE_LOCALE", locale);
    },
  },
  modules: {
    cart,
    productType,
    notification,
    data
  },
  getters: {
    getLocale: state => () => {
      return state.selectedLocale;
    },
    getTvaRate: state => () => {
      return state.config.TVA_RATE;
    }
  }
});
